import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  NotificationService,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_INFO,
  NOTIFICATION_DURATIONS,
} from 'ui-components/services/notification-service';

import { FulfillmentPlanOrderGridStatus } from '../../enums/fulfillmentplan-order-grid-status';
import { useEntitiesFulfillmentPlanProperty } from '../../hooks/entities/selectors/fulfillment-plans';
import { retryNotificationsPromise } from '../../store/send-notifications/send-notifications.api';
import { messages } from '../../store/send-notifications/messages';

export const useIsSendNotificationEnabledForShipment = (fulfillmentPlanId, returnId) => {
  const orderGridStatus = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'orderGridStatus') || {};
  const isShippedStatus = orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name;

  return isShippedStatus && !returnId;
};

export const useSendNotificationForShipment = (fulfillmentPlanIds) => {
  return useCallback(() => {
    NotificationService.showNotification({
      title: <FormattedMessage {...messages.sendingShipmentNotificationTitle} />,
      notificationType: NOTIFICATION_TYPE_INFO,
      content: <FormattedMessage {...messages.sendingShipmentNotificationContent} />,
      duration: NOTIFICATION_DURATIONS.SHORT,
    });

    // yes this is the same action as notify-marketplaces. The BE both sends notifications and notifies marketplaces.
    retryNotificationsPromise(fulfillmentPlanIds)
      .then(() => {
        NotificationService.showNotification({
          title: <FormattedMessage {...messages.shipmentNotificationSuccessTitle} />,
          notificationType: NOTIFICATION_TYPE_SUCCESS,
          content: <FormattedMessage {...messages.shipmentNotificationSuccessContent} />,
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
      })
      .catch(() => {
        NotificationService.showNotification({
          title: <FormattedMessage {...messages.shipmentNotificationErrorTitle} />,
          notificationType: NOTIFICATION_TYPE_ERROR,
          content: <FormattedMessage {...messages.shipmentNotificationErrorContent} />,
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
      });
  }, [fulfillmentPlanIds]);
};
